import { QuestionType } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

/**
 * Retorna o texto do tipo de questão.
 * @param props
 */
export const QuestionTypeText: React.FC<{ questionType: QuestionType }> = (props) => {

    const { questionType } = props;
    const { t } = useTranslation("assessment");

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {
                questionType == QuestionType.SimpleChoice || questionType == QuestionType.MultipleChoice
                    ? t("Common.QuestionType.MultipleChoice")
                    : questionType == QuestionType.Dropdown
                        ? t("Common.QuestionType.Dropdown")
                        : questionType == QuestionType.Essay
                            ? t("Common.QuestionType.Essay")
                            : questionType == QuestionType.FillInText || questionType == QuestionType.FillInNumber
                                ? t("Common.QuestionType.FillIn")
                                : t("Common.QuestionType.Star")

            }
        </>
    );
};
